module.exports = "images/doc-program-menu.fbcec1fee58b97d23c00de4bf5442a1f.png";